import React, { useState } from 'react';
import { View, StyleSheet, Image, ImageBackground } from 'react-native';
import BottomButton from '../BottomButton';
import WrapBottomColor from '../containers/WrapBottomColor';
import { CommonProperties, FontSize, Color, CommonStyles } from '../../styles';
import RowView from '../RowView';
import EventList from '../TripHub/Event/EventList';
import { useActionSheet } from '@expo/react-native-action-sheet';
import BaseText from '../BaseText';
import { userTypes } from '../../constants/Enums';

const InvitationModal = ({ navigation, route }) => {
  const [type, setType] = useState(userTypes.OWNER);
  const { showActionSheetWithOptions } = useActionSheet();
  return (
    <WrapBottomColor>
      <View style={styles.container}>
        <ImageBackground source={{ uri: 'https://picsum.photos/300' }} style={styles.mainImage}>
          <View style={styles.profileView}>
            <Image source={{ uri: 'https://picsum.photos/150' }} style={styles.profileImage} />
          </View>
        </ImageBackground>
        <RowView style={CommonStyles.flex1}>
          <View style={styles.bodyContent}>
            <BaseText style={styles.count}>12</BaseText>
            <BaseText style={styles.countText}>Messages</BaseText>
          </View>
          <View style={styles.seperator}></View>
          <View style={styles.headingContainer}>
            <BaseText style={styles.count}>2</BaseText>
            <BaseText style={styles.countText}>Joined</BaseText>
          </View>
        </RowView>
        <View style={{ flex: 5 }}>
          <BaseText style={styles.inviteText}>Jeffery H Invited you</BaseText>
          <BaseText style={{ fontSize: FontSize.h4 }}>
            That time of year folks, annual meet and greet. Make sure to get there by 10 AM june
            2021
          </BaseText>
          {/* <EventList userType={type} /> */}
        </View>
      </View>
      <BottomButton
        onPress={() => {
          showActionSheetWithOptions(
            {
              options: ['In person', 'Virtual', 'Undecided', 'Decline', 'Cancel'],
              cancelButtonIndex: 2,
            },
            (buttonIndex) => {}
          );
        }}
        label="Reply"
        full
      />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    padding: 10,
  },
  mainImage: {
    height: 200,
    width: '100%',
    resizeMode: 'contain',
    position: 'relative',
  },
  profileView: {
    backgroundColor: '#FFF',
    borderRadius: 55,
    padding: 3,
    position: 'absolute',
    bottom: '-15%',
    left: '35%',
    alignContent: 'center',
  },
  profileImage: {
    height: 110,
    width: 110,
    borderRadius: 75,
  },
  bodyContent: {
    flex: 1,
    alignItems: 'center',
    textAlign: 'center',
    ...CommonProperties.pt3,
  },
  count: {
    color: Color.primary,
    fontSize: FontSize.h3,
  },
  countText: {
    color: Color.text.low,
    fontSize: FontSize.h4,
  },
  seperator: {
    flex: 1,
    alignItems: 'center',
    textAlign: 'center',
  },
  headingContainer: {
    flex: 1,
    alignItems: 'center',
    textAlign: 'center',
    ...CommonProperties.pt3,
  },
  inviteText: {
    textAlign: 'center',
    fontSize: FontSize.h2,
  },
});

export default InvitationModal;
